import { useCart } from '../context/CartContext';
import './Cart.css';

export default function Cart() {
    const { cart, cartOpen, setCartOpen, loading, removeFromCart, updateQuantity } = useCart();

    const formatPrice = (amount, currency = 'EUR') => new Intl.NumberFormat('de-DE', { style: 'currency', currency }).format(amount);

    return (
        <>
            {/* Backdrop */}
            <div className={`cart-backdrop${cartOpen ? ' open' : ''}`} onClick={() => setCartOpen(false)} />

            {/* Drawer */}
            <aside className={`cart-drawer${cartOpen ? ' open' : ''}`}>
                <div className="cart-drawer-header">
                    <span className="cart-drawer-title">Warenkorb</span>
                    <button className="cart-close" onClick={() => setCartOpen(false)} aria-label="Schließen">
                        <svg
                            width="20"
                            height="20"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="1.6"
                            strokeLinecap="round"
                            strokeLinejoin="round">
                            <line x1="18" y1="6" x2="6" y2="18" />
                            <line x1="6" y1="6" x2="18" y2="18" />
                        </svg>
                    </button>
                </div>

                <div className="cart-drawer-body">
                    {!cart || cart.lines.length === 0 ? (
                        <p className="cart-empty">Dein Warenkorb ist leer.</p>
                    ) : (
                        <ul className="cart-items">
                            {cart.lines.map((line) => (
                                <li key={line.id} className="cart-item">
                                    {line.image && (
                                        <img src={line.image.url} alt={line.image.altText || line.productTitle} className="cart-item-img" />
                                    )}
                                    <div className="cart-item-info">
                                        <p className="cart-item-title">{line.productTitle}</p>
                                        {line.variantTitle !== 'Default Title' && <p className="cart-item-variant">{line.variantTitle}</p>}
                                        <p className="cart-item-price">{formatPrice(line.price * line.quantity, line.currency)}</p>
                                        <div className="cart-item-qty">
                                            <button
                                                onClick={() => updateQuantity(line.id, line.quantity - 1)}
                                                disabled={loading}
                                                aria-label="Weniger">
                                                −
                                            </button>
                                            <span>{line.quantity}</span>
                                            <button onClick={() => updateQuantity(line.id, line.quantity + 1)} disabled={loading} aria-label="Mehr">
                                                +
                                            </button>
                                        </div>
                                    </div>
                                    <button
                                        className="cart-item-remove"
                                        onClick={() => removeFromCart(line.id)}
                                        disabled={loading}
                                        aria-label="Entfernen">
                                        <svg
                                            width="14"
                                            height="14"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth="1.8"
                                            strokeLinecap="round"
                                            strokeLinejoin="round">
                                            <line x1="18" y1="6" x2="6" y2="18" />
                                            <line x1="6" y1="6" x2="18" y2="18" />
                                        </svg>
                                    </button>
                                </li>
                            ))}
                        </ul>
                    )}
                </div>

                {cart && cart.lines.length > 0 && (
                    <div className="cart-drawer-footer">
                        <div className="cart-total">
                            <span>Gesamt</span>
                            <span>{formatPrice(cart.total, cart.currency)}</span>
                        </div>
                        <a href={cart.checkoutUrl} className="checkout-btn" rel="noopener noreferrer">
                            Zur Kasse
                        </a>
                        <p className="cart-tax-note">inkl. MwSt. · Versand wird beim Checkout berechnet</p>
                    </div>
                )}
            </aside>
        </>
    );
}
